import front from './view';

export default [
  {
    path: 'my',
    redirect: 'my/progress',
  },
  {
    path: 'my/progress', // 심사신청현황목록
    component: front('/my/list/progressList'),
  },
  {
    path: 'my/progress/:sq', // 신청내용보기 (신규심사신청)
    component: front('/my/progressView'),
  },
  {
    path: 'my/requestEdit/:sq', // 신청서 수정
    component: front('/my/requestEdit'),
  },
  {
    path: 'my/cert', // 인증현황목록
    component: front('/my/certList'),
    children: [
      {
        path: '/',
        component: front('/my/list/statusList'),
        meta: { detail: '', api: 'certList' },
      },
      {
        path: 'regular3yList',
        component: front('/my/list/regularList'),
        meta: {
          detail: 'regular3y', api: 'regular/YR3', status: '유효', requireRole: 'COMPANY',
        },
      },
      {
        path: 'regular1yList',
        component: front('/my/list/regularList'),
        meta: {
          detail: 'regular1y', api: 'regular/YR1', status: '유효', requireRole: 'COMPANY',
        },
      },
      {
        path: 'addModelList',
        component: front('/my/list/addModelList'),
        meta: {
          detail: 'addModel', api: 'certList', status: '유효', requireRole: 'COMPANY',
        },
      },
      {
        path: 'moveFactoryList',
        component: front('/my/list/moveFactoryList'),
        meta: { detail: 'moveFactory', api: 'certList', requireRole: 'COMPANY' },
      },
      {
        path: 'changeMaterialList',
        component: front('/my/list/changeMaterialList'),
        meta: {
          detail: 'changeMaterial', api: 'materialList', requireRole: 'COMPANY',
        },
      },
      {
        path: 'successionList',
        component: front('/my/list/successionList'),
        meta: {
          detail: 'succession', api: 'successionList', status: '유효', requireRole: 'COMPANY',
        },
      },
      {
        path: 'stopResumeList',
        component: front('/my/list/stopResumeList'),
        meta: {
          detail: 'stopResume', api: 'stopResumeList', status: '유효', requireRole: 'COMPANY',
        },
      },
      {
        path: 'standardRevisionList',
        component: front('/my/list/standardRevisionList'),
        meta: {
          detail: 'standardRevision', api: 'standardRevisionList', status: '유효', requireRole: 'COMPANY',
        },
      },
      {
        path: 'reissueList',
        component: front('/my/list/reissueList'),
        meta: { detail: 'reissue', api: 'reissueList', requireRole: 'COMPANY' },
      },
    ],
  },
  {
    path: 'my/cert/detail/:certNo',
    component: front('/my/certView'),
  },
  {
    path: 'my/cert/regular3y', // 정기심사 신청 양식 3년
    component: front('/my/regular'),
  },
  {
    path: 'my/cert/regular1y', // 정기심사 신청 양식 1년
    component: front('/my/regular'),
  },
  {
    path: 'my/cert/addItem', // 품목 추가 신청 양식
    component: front('/my/addItem'),
  },
  {
    path: 'my/cert/addModel', // 종류 추가 신청 양식
    component: front('/my/addModel'),
  },
  {
    path: 'my/cert/moveFactory', // 공장이전심사대상목록
    component: front('/my/moveFactory'),
  },
  {
    path: 'my/cert/changeMaterial', // 자재 목록 변경 신청 양식
    component: front('/my/changeMaterial'),
  },
  {
    path: 'my/cert/succession', // 지위 승계 신청 양식
    component: front('/my/succession'),
  },
  {
    path: 'my/cert/stopResume', // 생산 중단/재개 신청
    component: front('/my/stopResume'),
  },
  {
    path: 'my/cert/standardRevision/:certNo', // KS 표준 및 심사기준 개정 신청
    component: front('/my/standardRevision'),
  },
  {
    path: 'my/cert/reissue', // 인증서 재발급 변경 신청
    component: front('/my/reissue'),
  },
  {
    path: 'my/cert/reissue/:sq', // 인증서 재발급 변경 상세
    component: front('/my/reissueDetail'),
  },
  {
    path: 'my/cert/reissueEng', // 영문 인증서 발급 신청
    component: front('/my/reissueEng'),
  },
  {
    path: 'my/cert/reissueEng/:sq', // 인증서 재발급 변경 상세
    component: front('/my/reissueEngDetail'),
  },
  {
    path: 'my/cert/evalComplete', // 심사신청 접수 완료
    component: front('/my/acceptEval'),
  },
  {
    path: 'my/cert/regularComplete', // 정기 심사신청 접수 완료
    component: front('/my/regularComplete'),
  },
  {
    path: 'my/cert/addItemComplete', // 품목추가 신청 접수 완료
    component: front('/my/addItemComplete'),
  },
  {
    path: 'my/cert/addModelComplete', // 종류,등급,호칭 또는 모델 추가 신청 접수 완료
    component: front('/my/addModelComplete'),
  },
  {
    path: 'my/cert/moveFactoryComplete', // 공장이전  신청 접수 완료
    component: front('/my/moveFactoryComplete'),
  },
  {
    path: 'my/cert/changeMaterialComplete', // 주요자재변경 신청 접수 완료
    component: front('/my/changeMaterialComplete'),
  },
  {
    path: 'my/cert/successionComplete', // 지위승계신청 접수 완료
    component: front('/my/successionComplete'),
  },
  {
    path: 'my/cert/stopResumeComplete', // 지위승계신청 접수 완료
    component: front('/my/stopResumeComplete'),
  },
  {
    path: 'my/cert/reissueComplete', // 인증서 재발급 / 변경신청 접수 완료
    component: front('/my/reissueComplete'),
  },
  {
    path: 'my/cert/reissueEngComplete', // 영문 인증서 신청 접수 완료
    component: front('/my/reissueEngComplete'),
  },

  {
    path: 'my/cert/retrialForm', // 재심사 작성
    component: front('/my/retrialForm'),
  },

  //
  // {
  //   path: 'my/cert/regular3Y', // 정기심사대상목록3년
  //   component: front('/my/regularTarget3Y'),
  // },
  // {
  //   path: 'my/cert/regular1Y', // 정기심사대상목록1년
  //   component: front('/my/regularTarget1Y'),
  // },
  // {
  //   path: 'my/evalTargetList', // 심사대상목록(종류추가)
  //   component: front('/my/evalTargetList'),
  // },
  // {
  //   path: 'my/itemChangeList', // 주요자재 변경 신청 대상목록
  //   component: front('/my/itemChangeList'),
  // },
  // {
  //   path: 'my/certificateStatus', // 인증서 재발급 신청 현황
  //   component: front('/my/certificateStatus'),
  // },
  {
    path: 'my/cert/requestDoneAfter', // 신청접수 완료 후
    component: front('/my/requestDoneAfter'),
  },

  // {
  //   path: 'my/resumeList', // 생산중단 재개 대상목록
  //   component: front('/my/resumeList'),
  // },
  // {
  //   path: 'my/normalConditionList', // 표준 및 심사 기준 대상 및 현황
  //   component: front('/my/normalConditionList'),
  // },
  // {
  //   path: 'my/reissueList', // 인증서 재발급 변경 현황
  //   component: front('/my/reissueList'),
  // },
  // {
  //   path: 'my/successionAfter', // 지위 승계 신청서
  //   component: front('/my/successionAfter'),
  // },
  // {
  //   path: 'my/standardEvalTarget', // KS 표준 및 심사기준 대상 및 현황
  //   component: front('/my/standardEvalTarget'),
  // },
  // {
  //   path: 'my/factoryMoveList', // 공장이전심사대상목록
  //   component: front('/my/factoryMoveList'),
  // },

  // info
  {
    path: 'my/info', // 내 정보확인
    redirect: 'my/info/edit/check',
  },
  {
    path: 'my/info/payment', // 결제 내역
    component: front('/my/info/payment'),
  },
  {
    path: 'my/info/edit/check', // 정보변경 비밀번호 확인
    component: front('/my/info/check'),
  },
  {
    path: 'my/info/edit', // 내 정보변경
    component: front('/my/info/edit'),
  },
  {
    path: 'my/info/pwd', // 내 정보변경
    component: front('/my/info/pwd'),
  },
  {
    path: 'my/info/qna', // MY Q&A
    component: front('/my/info/qna'),
  },
  {
    path: 'my/info/qna/:sq',
    component: front('/my/info/qnaDetail'),
  },
];



// WEBPACK FOOTER //
// ./src/router/front/my.js